import { useEffect } from 'react';
import shallow from 'zustand/shallow';
import useAuthStore from 'store/auth';
import AppLoading from 'components/AppLoading';
import AuthRouter from 'router/AuthRouter';
import { Main } from 'components';
import { TraderProvider } from 'context/TraderTypeContext';

function App() {
  const [isLoggedIn, isLoading, getUser, isError, signOut, resetInactivityTimer] = useAuthStore(
    (state) => [
      state.isLoggedIn,
      state.isLoading,
      state.getUser,
      state.isError,
      state.signOut,
      state.resetInactivityTimer,
    ],
    shallow
  );

  useEffect(() => {
    if (isLoggedIn) getUser();
  }, [getUser, isLoggedIn]);

  useEffect(() => {
    if (isError) signOut();
  }, [isError, signOut]);

  useEffect(() => {
    console.log("Ver: ", process.env.REACT_APP_VERSION )
    if (!isLoggedIn) return;

    const events = ['mousedown', 'keypress', 'scroll', 'touchstart'];
    const handleActivity = () => resetInactivityTimer();

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        const lastActivityTime = localStorage.getItem('lastActivityTime');
        if (!lastActivityTime) return;

        const elapsed = Date.now() - parseInt(lastActivityTime, 10);
        if (elapsed >= 30 * 60 * 1000) {
          signOut();
        } else {
          resetInactivityTimer();
        }
      }
    };

    events.forEach((event) => window.addEventListener(event, handleActivity));
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      events.forEach((event) => window.removeEventListener(event, handleActivity));
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isLoggedIn, signOut, resetInactivityTimer]);

  if (isLoggedIn && isLoading) {
    return <AppLoading />;
  }

  if (isLoggedIn) {
    return (
      <TraderProvider>
        <Main />
      </TraderProvider>
    );
  }

  return <AuthRouter />;
}

export default App;